import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreComponentsModule } from './core/components/components.module';
import { PagesModule } from './pages/pages.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { LoaderService } from './core/services/loader.service';
import { ThemeService } from './core/services/theme.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    CoreComponentsModule,
    PagesModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [
    LoaderService,
    ThemeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
